"use strict";

exports.__esModule = true;
exports.default = stringifyRecordValues;

var _sanitizeRow = require("./sanitize-row");

var _stringifyObjectValues = require("./stringify-object-values");

// Stringifies the values of a record, ignoring any special top level field keys
// TODO: add option to strigify formatted/scopedSlot items, and only specific fields
function stringifyRecordValues(row) {
  /* istanbul ignore else */
  if (row instanceof Object) {
    return (0, _stringifyObjectValues.default)((0, _sanitizeRow.default)(row));
  } else {
    /* istanbul ignore next */
    return '';
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/components/table/helpers/stringify-record-values.js
// module id = 593
// module chunks = 0 1